// extracted by mini-css-extract-plugin
export default {"root":"ScanWiseTable_root__EEoL7","small":"ScanWiseTable_small__Unyv0"};